import React, { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { createMsg } from 'src/core/engine/actionCreators';

import { Size } from '../../ProductDetail/ProductSizes';
import { BaseVariant } from '../../ProductDetail/utils/product-detail.types';

interface Props {
    variant: BaseVariant;
    parentSku: string | null;
    quantity: number;
    setQuantity: React.Dispatch<React.SetStateAction<number>>;
    setSize: React.Dispatch<React.SetStateAction<number | string>>;
    setColor: React.Dispatch<React.SetStateAction<number>>;
    sizes: Size[];
    color: number;
}

type Messages = {
    ['Cart.Add.Config']: any;
};
const Msg = createMsg<Messages>();
const CartMsg = Msg;

export const BasketUpsellForm: React.FC<React.PropsWithChildren<Props>> = React.memo((props) => {
    const { variant, parentSku, quantity, setQuantity, setSize, sizes, setColor, color } = props;
    const dispatch = useDispatch();
    const submitForm = useCallback(
        (e) => {
            e.preventDefault();

            const items = [
                {
                    data: {
                        quantity: +quantity,
                        sku: variant.sku,
                    },
                    parent_sku: String(parentSku),
                    variant_sku: String(variant.sku),
                },
            ];

            const upsellsArray = [] as any;
            const upsellsLS = JSON.parse(localStorage.getItem('upsellItems') || '[]');

            upsellsArray.push(...upsellsLS, ...items);

            const skus = upsellsArray.map(({ parent_sku }) => parent_sku);
            const filteredupsellsArray = upsellsArray.filter(
                ({ parent_sku }, index) => !skus.includes(parent_sku, index + 1),
            );

            localStorage.setItem('upsellItems', JSON.stringify(filteredupsellsArray));

            // Send request
            dispatch(CartMsg('Cart.Add.Config', { items: items, upsell: true }));

            // Reset form
            setQuantity(0);
            setSize(sizes[0].id);
            setColor(color);
        },
        [dispatch, parentSku, quantity, variant, setQuantity, setSize, sizes, color, setColor],
    );

    return <form onSubmit={submitForm}>{props.children}</form>;
});
